export const isFettesHost = () => {
    if (typeof window === 'undefined') {
        return false
    }
    const hostname = window.location.hostname
    return hostname === 'fettes.com' || hostname.endsWith('.fettes.com')
}
